import { render, staticRenderFns } from "./buttonLayoutConfigurationModal.vue?vue&type=template&id=d0c642ca&scoped=true"
import script from "./buttonLayoutConfigurationModal.vue?vue&type=script&lang=js"
export * from "./buttonLayoutConfigurationModal.vue?vue&type=script&lang=js"
import style0 from "./buttonLayoutConfigurationModal.vue?vue&type=style&index=0&id=d0c642ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c642ca",
  null
  
)

export default component.exports